import React from 'react';
import SiteHeader from './SiteHeader';

/**
 * App shell navigation (dashboard and inner pages). Thin wrapper over SiteHeader.
 */
function AppNavbar({ onLogout, activeSection = 'dashboard' }) {
  return <SiteHeader variant="app" activeAppSection={activeSection} onLogout={onLogout} />;
}

export default AppNavbar;
